module.exports = __webpack_public_path__ + "img/eco8.da3e122d.png";